<template>
    <div>
        <v-layout row class="mb-4">
            <v-flex md6 sm12 xs12 justify-start>
                <h3 class="subheading font-weight-regular mb-3">{{ authenticatedUser.is_administrator ? 'Add Member' : 'Owner'}}</h3>
                <v-autocomplete
                        :item-text="getUserLabel"
                        :items="owners"
                        :loading="(!create && !monitorFetchReady) || !userAllFetchReady"
                        background-color="#e2e2e2"
                        class="custom-box"
                        height="41"
                        item-value="uuid"
                        label="Select Owner"
                        outline
                        single-line
                        v-model="selectOwner"
                        v-show="authenticatedUser.is_superadministrator"
                >
                    <template slot="progress">
                        <v-progress-linear color="bindezcolor" height="2" indeterminate></v-progress-linear>
                    </template>
                    <template slot="selection" slot-scope="{item}">
                        {{ item.name}}
                    </template>
                </v-autocomplete><br>
                <!-- v-show="authenticatedUser.is_administrator" -->
                <v-text-field
                        height="41"
                        v-show="authenticatedUser.is_administrator || authenticatedUser.is_superadministrator"
                        ref="adduser"
                        v-model="member"
                        label="Add Team Member"
                        :loading="member !== undefined && !checkUserReady"
                        outline
						single-line
						background-color="#e2e2e2"
                        color="bindezcolor"
						class="custom-box"
                        :error-messages="emailErrors"
                        required
                ></v-text-field>
                <!-- v-show="authenticatedUser.is_administrator" -->
                <v-layout v-show=" authenticatedUser.is_administrator || authenticatedUser.is_superadministrator" row wrap>
                    <v-flex class="access-group--height" d-flex md8 sm12 xs12 align-center>
                        <v-checkbox
                                :ripple="false"
                                color="bindezcolor"
                                label="Read Access"
                                hide-details
                                v-model="readAccess"
                        />
                        <v-checkbox
                                :ripple="false"
                                color="bindezcolor"
                                label="Write Access"
                                hide-details
                                v-model="writeAccess"
                        />
                    </v-flex>
                    <v-flex xs12>
                        <span v-show="!readAccess && !writeAccess" style="color:#EB2929">At Least One Access is Required</span>
                    </v-flex>
                </v-layout>
                <!-- v-show="authenticatedUser.is_administrator" -->
                <v-btn
                        v-show=" authenticatedUser.is_administrator || authenticatedUser.is_superadministrator"
                        class="mx-0"
                        color="bindezcolor"
                        dark
                        @click="addMember"
                >
                    <span class="text-capitalize">Add User</span>
                </v-btn>
            </v-flex>
            <v-flex md6 sm12 xs12></v-flex>
        </v-layout>
        <v-dialog
                v-model="dialog"
                max-width="600"
                persistent
        >
            <v-card>
                    <v-flex v-if="errorMsg !== undefined && dialogType === 'warning'" md12 sm12 xs12>
                        <v-card-text>
                            <div class="d-flex fill-height justify-center align-center">
                                <v-icon
                                        class="mr-4"
                                        color="bindezcolor"
                                        :size="60"
                                >
                                    fas fa-exclamation-circle
                                </v-icon>
                                <span v-html="dialogMessages"></span>
                            </div>
                        </v-card-text>
                    </v-flex>
                    <v-flex v-if="dialogType === 'delete'" md12 sm12 xs12>
                        <v-card-text>
                            <div class="d-flex fill-height justify-center align-center">
                                <v-icon
                                    color="bindezcolor"
                                    :size="60"
                                >
                                    fas fa-exclamation-circle
                                </v-icon>
                                <span class="title font-weight-bold">Do you want to Delete this user?</span>
                            </div>
                        </v-card-text>
                    </v-flex>
                    <div v-if="dialogType === 'warning'" class="mt-4 text-xs-right">
                        <v-btn
                                @click="dialog = false "
                                dark
                                color="bindezcolor"
                                style="width: 150px;"
                        >OK
                        </v-btn>
                    </div>
                    <v-card-actions v-if="dialogType === 'delete'" class="pa-3">
                        <v-btn
                                @click="dialog = false"
                                outline
                                block
                                large
                                color="bindezcolor"
                        >Cancel
                        </v-btn>
                        <v-btn
                                @click="deleteMember"
                                block
                                large
                                dark
                                color="bindezcolor"
                        >Yes, Delete
                        </v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- v-show="authenticatedUser.is_administrator" -->
        <v-data-table
                v-show=" authenticatedUser.is_administrator || authenticatedUser.is_superadministrator"
                v-model="selectedTeams"
                :headers="headers"
                :items="membersAddedToMonitor"
                item-key="id"
                class="elevation-2"
                hide-actions
                select-all
        >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th
                            v-for="header in props.headers"
                            :key="header.text"
                            class="subheading text-xs-left"
                    >
                        {{header.text}}
                    </th>
                </tr>
            </template>
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-xs-left body-2">{{props.item.name}}</td>
                    <td class="text-xs-left body-2">{{props.item.email}}</td>
                    <td class="text-xs-left body-2">
                        {{ (props.item.access.write && props.item.access.read) ? 'Write/Read' : props.item.access.read ?
                        'Read' : 'Write' }}
                    </td>
                    <td class="text-xs-left body-2">{{props.item.status}}</td>
                    <td>
                        <v-icon size="13" class="add-cursor" @click.stop="dialog = true; dialogType = 'delete'; delUser = props.item">
                            far fa-trash-alt
                        </v-icon>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <div class="mt-3 text-xs-right">
            <v-btn
                    depressed
                    @click="$emit('next', 'update')"
                    color="bindezcolor"
                    dark
                    :loading="processing"
            ><span class="text-capitalize">{{ create ? 'Create Monitor' : 'Update Monitor'}}</span></v-btn>
        </div>
    </div>
</template>

<script>
	import {required, email} from 'vuelidate/lib/validators'
	import {mapState, mapMutations, mapActions} from 'vuex'
    import authCurrentUser from '@/mixins/authCurrentUser';
	export default {
		name: "TeamsSection",
		props: ['create','processing'],
        mixins: [authCurrentUser],
		data() {
			return {
				checkUserReady: true,
                user: {},
                delUser: {},
				errorMsg: undefined,
                dialog: false,
                dialogType: undefined,
				selectedTeams: [],
				selectedEmail: [],
				readAccess: false,
				writeAccess: false,
				member: undefined,
				//searchEmail: null,
				headers: [
					{text: "Name", sortable: false, value: "name"},
					{text: "Email", sortable: false, value: "email"},
					{text: "Permission", sortable: false, value: "access"},
					{text: "Status", sortable: false, value: "status"},
					{text: "Options", sortable: false, value: "option"}
				],
				team: [],
			}
		},
		validations: {
            member:{
                email,
                required
            },
		},
		computed: {
			...mapState('monitors', [
				'users',
				'assignedUser',
                'owner',
                'monitorFetchReady'
			]),

			...mapState([
				'monitor',
                'userAllFetchReady'
			]),

			owners() {
				return this.users.filter(user => {
					return user.roles.hasOwnProperty('administrator')
						|| user.roles.hasOwnProperty('superadministrator');
				})
			},

            selectOwner:{
				get(){
					return this.owner
                },
                set(owner){
					this.setMonitorOwner(owner)
                }
            },

            membersAddedToMonitor:{
				get(){
					return this.assignedUser;
                },
                set(members){
					this.assignUserToMonitor(members);
                }
            },

			emailErrors() {
				const errors = [];
				if (!this.$v.member.$dirty) return errors
				!this.$v.member.email && errors.push("Invalid Email");
				!this.$v.member.required && errors.push("Email is required");
				return errors
			},

			dialogMessages: {
				get() {
					return this.errorMsg
				},
				set(val) {
					this.errorMsg = `<span class="title font-weight-bold">${val}</span>`
				}
			},

		},
		methods: {
			...mapMutations('monitors', [
				'setMonitorOwner',
				'assignUserToMonitor',
                'setUsers'
			]),

			...mapActions('monitors', [
				'getUserByEmail',
				'removeUserMonitorAccess',
                'fetchUsers'
            ]),

			...mapActions([
				'fetchAllResource'
			]),

			getUserLabel(user) {
				return `${user.name} <${user.email}>`
			},

			deleteMonitorMember() {
				this.$ua.trackEvent("Monitor", "click", `Delete Member from Monitor By Administrator(${this.authenticatedUser.email || 'User'}`);
				let team = this.membersAddedToMonitor;
				team.splice(team.indexOf(this.delUser), 1);
				this.membersAddedToMonitor = team;
			},

			deleteMember() {
				if (!this.create) {
					this.removeUserMonitorAccess({monitor_uuid: this.monitor.monitor_uuid, user_uuid: this.delUser.user_uuid})
						.then(() => {
							this.deleteMonitorMember();
                            this.dialog = false
                    });
				} else {
					this.deleteMonitorMember();
                    this.dialog = false
				}
			},

			monitorAction() {
				this.$emit('next', {update: true, user_uuid: this.user.uuid})
			},

            resetOldMemberValue(){
				this.readAccess = false;
				this.writeAccess = false;
				this.member = '';
            },

			addMember() {
				this.$v.$touch();
				this.$ua.trackEvent("Monitor", "click",`Add Member to Monitor By Administrator(${this.authenticatedUser.email || 'User'}`);
				if (!this.$v.$invalid && (this.readAccess || this.writeAccess)) {
					this.checkUserReady = false;
					this.getUserByEmail(this.member)
						.then(({data}) => {
							if (!this.membersAddedToMonitor.find(member => member.user_uuid === data.uuid)) {
								let {name, email, status, uuid} = data;
								let team = this.membersAddedToMonitor;
								team.push({
									name,
									email,
									access: {read: this.readAccess, write: this.writeAccess},
									status,
									user_uuid: uuid
								});
								this.membersAddedToMonitor = team;
							}
							this.checkUserReady = true;
							this.$refs.adduser.focus();
							this.$v.$reset();
							this.resetOldMemberValue();
						}).catch((error) => {
						if (error.response) {
							this.checkUserReady = true;
							this.dialogType = 'warning';
							this.dialog = true;
							this.dialogMessages = `Sorry, <strong>${this.member}</strong> is not recognized as an active username or email address`;
							this.resetOldMemberValue();
							this.$v.$reset();
						}
					})
				}

			}
		},

		created() {
			if (this.create) this.selectOwner = this.authenticatedUser.uuid;
			if (this.authenticatedUser.is_superadministrator) {
				this.fetchAllResource({
                    resourceType:"User",
                    resourceAction: "monitors/fetchUsers"
                }).then(this.setUsers)
			}
		},
	}
</script>

<style scoped>
    .access-group--height {
        height: 45px;
    }

    .access-group-message--color {
        color: #ff5252;
    }

    .access-group-message--size {
        font-size: 12px;
    }

    .add-cursor {
        cursor: pointer;
    }
</style>
